export function isHorizontalFirstLetter(origin: string[][], x: number, y: number): boolean {
  return !origin[y]?.[x - 1] && !!origin[y]?.[x + 1] && !!origin[y][x]
}